<template>
  <div>
    <Page />
    <CookieBox />
  </div>
</template>

<script>

import Page from '@/components/Page.vue';
import CookieBox from '@/components/CookieBox.vue';

export default {
  name: 'Home',
   title: 'Strona główna',
  components: {
    Page,
    CookieBox
  }
}
</script>
